<template>
  <div>{{ model }}</div>
</template>

<script>
export default {
  name: "textField",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form"],
  created() {},
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
